import React, { useEffect } from "react";
import "@/App.css";
// BrowserRouter on web so each screen has its own pathname (so Vercel
// Analytics can report Pages/Routes). HashRouter on native because the
// Capacitor WebView serves from capacitor://localhost and hash routes
// avoid history/basename mismatches.
import { BrowserRouter, HashRouter, Routes, Route, useLocation } from "react-router-dom";
import HomeScreen from "@/pages/HomeScreen";
import PlayScreen from "@/pages/PlayScreen";
import ShopScreen from "@/pages/ShopScreen";
import MiniGamesScreen from "@/pages/MiniGamesScreen";
import TargetsScreen from "@/pages/TargetsScreen";
import PrivacyPolicyScreen from "@/pages/PrivacyPolicyScreen";
import SupportScreen from "@/pages/SupportScreen";
import { Toaster } from "sonner";
import { Capacitor } from "@capacitor/core";
import { StatusBar } from "@capacitor/status-bar";
import { Analytics } from "@vercel/analytics/react"

export default function App() {
  useEffect(() => {
    // On a native device, hide the iOS/Android status bar so the game
    // WebView goes fully edge-to-edge. No-op on the web build.
    if (!Capacitor.isNativePlatform()) return;
    StatusBar.hide().catch(() => {});
  }, []);

  const Router = Capacitor.isNativePlatform() ? HashRouter : BrowserRouter;

  return (
    <div className="App" data-testid="app-root">
      <Router>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/play" element={<PlayScreen mode="classic" />} />
          <Route path="/play/:mode" element={<PlayScreen />} />
          <Route path="/shop" element={<ShopScreen />} />
          <Route path="/shop/:tab" element={<ShopScreen />} />
          <Route path="/minigames" element={<MiniGamesScreen />} />
          <Route path="/targets" element={<TargetsScreen />} />
          <Route path="/privacy" element={<PrivacyPolicyScreen />} />
          <Route path="/support" element={<SupportScreen />} />
        </Routes>
        {!Capacitor.isNativePlatform() && <VercelAnalytics />}
      </Router>
      <Toaster
        position="top-center"
        richColors
        theme="dark"
        offset="calc(env(safe-area-inset-top) + 16px)"
        mobileOffset="calc(env(safe-area-inset-top) + 16px)"
      />
    </div>
  );
}

// Resolve the concrete pathname to the matching <Route path=""> pattern so
// Vercel Analytics groups dynamic routes (e.g. every /play/:mode) into one
// page entry instead of showing one row per concrete URL.
function pathToRoutePattern(pathname) {
  if (pathname === "/play" || pathname.startsWith("/play/")) return "/play/:mode";
  return pathname || "/";
}

function VercelAnalytics() {
  const { pathname } = useLocation();
  return <Analytics route={pathToRoutePattern(pathname)} />;
}
